export const GET_TRM_CONFIGURATIONS = 'GET_TRM_CONFIGURATIONS';
export const GET_TRM_CONFIGURATIONS_SUCCESS = 'GET_TRM_CONFIGURATIONS_SUCCESS';
export const GET_TRM_CONFIGURATIONS_FAIL = 'GET_TRM_CONFIGURATIONS_FAIL';
export const PUT_TRM_CONFIGURATIONS = 'PUT_TRM_CONFIGURATIONS';
export const PUT_TRM_CONFIGURATIONS_SUCCESS = 'PUT_TRM_CONFIGURATIONS_SUCCESS';
export const PUT_TRM_CONFIGURATIONS_FAIL = 'PUT_TRM_CONFIGURATIONS_FAIL';
export const TRM_CONFIGURATIONS_RESET = 'TRM_CONFIGURATIONS_RESET';

export function unMountTRMConfigurations(payload) {
  return {
    type: TRM_CONFIGURATIONS_RESET,
    payload
  };
}

export function getTRMConfigurations(payload) {
  return {
    type: GET_TRM_CONFIGURATIONS,
    payload
  };
}

export function getTRMConfigurationsSuccess(payload) {
  return {
    type: GET_TRM_CONFIGURATIONS_SUCCESS,
    payload
  };
}

export function getTRMConfigurationsFail(payload) {
  return {
    type: GET_TRM_CONFIGURATIONS_FAIL,
    payload
  };
}

export function putTRMConfigurations(payload) {
  return {
    type: PUT_TRM_CONFIGURATIONS,
    payload
  };
}

export function putTRMConfigurationsSuccess(payload) {
  return {
    type: PUT_TRM_CONFIGURATIONS_SUCCESS,
    payload
  };
}

export function putTRMConfigurationsFail(payload) {
  return {
    type: PUT_TRM_CONFIGURATIONS_FAIL,
    payload
  };
}
